import { setAddonVoyageProtection, setHasIncludedGratuities } from '@/ducks/travelParty/slice';

export const ADD_ONS_SEARCH_PARAM = 'addOns';
export const VOYAGE_PROTECTION_ADD_ON_CODE = 'VP';
export const SERVICE_CHARGE_ADD_ON_CODE = 'GRATUITIESPRE';
export const BAR_TAB_ADD_ON_MASK = /^BSL\s[0-9]+$/;
export const ADDED_ADDONS_SESSION_KEY = 'trulyAddedAddons';

export const BAR_TAB_MAX_TOTAL_PRICE = 2000;
export const BAR_TAB_MAX_DAYS_BEFORE_SAILING = 7;

export const ADDONS_WITHOUT_QUANTITIES = [VOYAGE_PROTECTION_ADD_ON_CODE, SERVICE_CHARGE_ADD_ON_CODE];

/**
 * Add these add-ons to calc-invoice by default then manually subtract it if user didn't add it
 * Approach to reduce calc-invoice calls amount @see https://virginvoyages.atlassian.net/browse/MSH-138434
 */
export const ADDONS_ADDED_TO_INVOICE_BY_DEFAULT = [SERVICE_CHARGE_ADD_ON_CODE, VOYAGE_PROTECTION_ADD_ON_CODE];

export const ADDONS_ACTIONS = {
  [SERVICE_CHARGE_ADD_ON_CODE]: setHasIncludedGratuities,
  [VOYAGE_PROTECTION_ADD_ON_CODE]: setAddonVoyageProtection,
};
